import { CursorPaginationResult } from "@/types/CursorPaginationResult";
import { Axios } from "@/utils/axios";

export interface Question {
  id: number;
  author: string;
  content: string;
  created_at: string;
  status: "답변 대기 중" | "답변 완료";
  tags: string[];
  is_users: boolean;
}
export const getQuestions = (tag: string | undefined) => {
  return async ({ pageParam = "" }) => {
    const page = pageParam ? new URL(pageParam).searchParams.get("page") : undefined;

    const { data } = await Axios.get<CursorPaginationResult<Question>>("/questions/", {
      params: {
        page,
        tag,
      },
    });
    return data;
  };
};
